import { API } from "./constants";
import { urlInterpolate } from "../utils/url";
import { API_V4_BASE as URL_BASE } from "../env";

/*
Set of api action create helpers
Similar to GRAPHQL set of action creators
*/

export const createApiAction = (config, TYPES) => {
  const {
    url,
    query,
    params,
    body,
    method = "GET",
    redirect,
    headers,
    absolute,
  } = config;

  return {
    url: `${absolute ? "" : URL_BASE}/v1${urlInterpolate(
      url,
      query || {},
      params || {},
    )}`,
    query,
    params,
    body,
    method: method.toUpperCase(),
    successRedirect: redirect,
    type: API,
    types: TYPES,
    headers,
  };
};

export const createRequestAction = (apiAction) => ({
  ...apiAction,
  type: apiAction.types.REQUEST,
});

export const createSuccessAction = (apiAction, body, status) => ({
  ...apiAction,
  data: body,
  status,
  redirect: apiAction.successRedirect,
  type: apiAction.types.SUCCESS,
});

export const createFailureAction = (apiAction, error, description) => ({
  ...apiAction,
  redirect: null,
  error,
  description,
  type: apiAction.types.FAILURE,
});

export const createAsyncActionRequestTypes = (base) =>
  ["REQUEST", "SUCCESS", "FAILURE"].reduce((res, type) => {
    res[type] = `${base}_${type}`;
    return res;
  }, {});
